const HASH = 'oZ9ydSmxeFpexElLvEco';
const ORDERID = new Date().getTime();

function getOrderId() {
  try {
    if (window && window.ga) {
      const gtms = window.ga.getAll();
      return gtms[gtms.length - 1].get('_ti');
    }
  } catch (err) {
    console.info(err);
  }
  return ORDERID;
}

function runScrpt(rtbhTags = []) {
  try {
    const prefix = '';
    const key = '__rtbhouse.lid';
    let lid = window.localStorage.getItem(key);

    if (!lid) {
      lid = '';
      const pool = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (let i = 0; i < 20; i += 1) lid += pool.charAt(Math.floor(Math.random() * pool.length));
      window.localStorage.setItem(key, lid);
    }

    rtbhTags.push(`pr_${HASH}_lid_${lid}`);

    const ifr = document.createElement('iframe');
    const sr = encodeURIComponent(document.referrer ? document.referrer : '');
    const su = encodeURIComponent(document.location.href ? document.location.href : '');
    let ifrSrc = `https://${prefix}creativecdn.com/tags?type=iframe`;
    const tmstmp = encodeURIComponent(`${Date.now()}`);

    for (let i = 0; i < rtbhTags.length; i += 1) {
      ifrSrc += `&id=${encodeURIComponent(rtbhTags[i])}`;
    }
    ifrSrc += `&su=${su}&sr=${sr}&ts=${tmstmp}`;
    ifr.setAttribute('src', ifrSrc);
    ifr.setAttribute('width', '1');
    ifr.setAttribute('height', '1');
    ifr.setAttribute('scrolling', 'no');
    ifr.setAttribute('frameBorder', '0');
    ifr.setAttribute('style', 'display:none');
    ifr.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    if (document.body) {
      document.body.appendChild(ifr);
    } else {
      window.addEventListener('DOMContentLoaded', () => {
        document.body.appendChild(ifr);
      });
    }
  } catch (e) {
    console.error(e);
  }
}

function fireEvent(params = {}) {
  const { orderId, value, event, category } = params;
  let { ids } = params;
  if (!Array.isArray(ids)) ids = [];

  let tag = `pr_${HASH}`;

  if (category) tag += `_${category}`;

  if (value) tag += `_${value.replace ? value.replace(/\s+/g, '') : value}`;
  else if (category === 'orderstatus2') tag += '_1';

  if (orderId) tag += `_${orderId}`;
  if (event) tag += `-${event}`;
  if (ids && ids.length) tag += `_${ids.join(',')}`;

  runScrpt([tag]);
}

function homePageView() {
  fireEvent({ category: 'home' });
}

function otherPageView(params) {
  // fireEvent({
  //   orderId: getOrderId(),
  //   ...params,
  //   event: 'websitevisit_1',
  //   category: 'orderstatus2',
  // });
  fireEvent();
}

function fireEventLeasing(params) {
  fireEvent({
    orderId: getOrderId(),
    ...params,
    event: 'leasing',
    category: 'orderstatus2',
  });
}

function fireEventLeasingOld(params) {
  fireEvent({
    orderId: getOrderId(),
    ...params,
    event: 'leasingold',
    category: 'orderstatus2',
  });
}

function fireEventLeasingNew(params) {
  fireEvent({
    orderId: getOrderId(),
    ...params,
    event: 'leasingnew',
    category: 'orderstatus2',
  });
}

function fireEventTestDrive(params) {
  fireEvent({
    orderId: getOrderId(),
    ...params,
    event: 'testdrive',
    category: 'orderstatus2',
  });
}

function fireEventTradeIn(params) {
  fireEvent({
    orderId: getOrderId(),
    ...params,
    event: 'tradein',
    category: 'orderstatus2',
  });
}

function fireEventCallback(params) {
  fireEvent({
    orderId: getOrderId(),
    ...params,
    event: 'callback',
    category: 'orderstatus2',
  });
}

function fireEventShownumber(params) {
  fireEvent({
    orderId: getOrderId(),
    ...params,
    event: 'shownumber',
    category: 'orderstatus2',
  });
}

function fireEventPartsShownumber(params) {
  fireEvent({
    orderId: getOrderId(),
    ...params,
    event: 'partshownumber',
    category: 'orderstatus2',
  });
}

function fireEventCategory(params) {
  fireEvent({ ...params, category: 'category2' });
}

function fireEventOffer(params) {
  fireEvent({ ...params, category: 'offer' });
}

export const fireRTBPageView = path => {
  const pages = {
    '/': homePageView,
  };
  const categories = [
    'avto',
    'mototsikl',
    'skuter',
    'kvadrotsikl',
    'karting',
    'moped',
    'baggi',
    'tritsikl',
    'gruzovye',
    'avtobus',
    'pritsepy',
    'spetstehnika',
    'commercial',
    'moto',
    'vodnyi-transport',
    'snegohod',
    'vezdehod',
  ];

  if (pages[path]) return pages[path]();
  const pathes = path.trim().split('/').filter(str => !!str);
  if (pathes && categories.includes(pathes[0])) {
    return fireEventCategory({
      value: path,
    });
  }
  const lastPath = Array.isArray(pathes) && pathes.pop();
  if (lastPath && /\.html$/.test(lastPath)) {
    const adv = lastPath.match(/(\d+)-*(\d)?\.html$/);
    if (adv[1]) return fireEventOffer({ ids: [adv[1]] });
  }

  otherPageView();
};

export const fireRTBEvent = (name, params) => {
  const events = {
    leasing: fireEventLeasing,
    leasingOld: fireEventLeasingOld,
    leasingNew: fireEventLeasingNew,
    formTestDrive: fireEventTestDrive,
    formTradeIn: fireEventTradeIn,
    formCallback: fireEventCallback,
    category: fireEventCategory,
    showNumber: fireEventShownumber,
    showPartsNumber: fireEventPartsShownumber,
  };
  if (events[name]) events[name](params);
};



// WEBPACK FOOTER //
// ./src/shared/helpers/rtbHouse.js